export default __webpack_public_path__ + "static/media/ts-icon.764e13c1.svg";